import { inject, Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorNotificationService {
  private readonly notificationService = inject(NotificationService);
  private readonly blacklistedBrowserAgents = [
    'ahrefs',
    'adsbot',
    'claudebot',
    'Acunetix',
    'Deepscan',
    'Prerender',
    'crawler',
    'amazonbot',
    'Googlebot',
    'prerender',
    'bingbot',
    'yandex',
    'baiduspider',
    'facebookexternalhit',
    'twitterbot',
    'rogerbot',
    'linkedinbot',
    'embedly',
    'quora link preview',
    'showyoubot',
    'outbrain',
    'pinterest',
    'slackbot',
    'vkShare',
    'W3C_Validator',
    'redditbot',
    'Applebot',
    'WhatsApp',
    'HeadlessChrome',
    'SEBot-WA',
  ];
  private readonly cachedErrors: Record<string, Error> = {};

  notifyError(title: string, message: string, error: Error) {
    const showErrorToast = (title: string, message: string, error: Error) => {
      this.showErrorToast(title, message, error);
    };
    this.onError(showErrorToast, title, message, error);
  }

  notifyApiError(title: string, message: string, error: HttpErrorResponse) {
    const showErrorToast = (title: string, message: string, error: HttpErrorResponse) => {
      this.showApiErrorToast(title, message, error);
    };
    this.onError(showErrorToast, title, message, error);
  }

  private onError(showToastFn: any, title: string, message: string, error: Error | HttpErrorResponse) {
    if (this.shouldSendError(error)) {
      this.cacheError(error);
      showToastFn(title, message, error);
    }
  }

  private showErrorToast(title: string, message: string, error: Error | undefined) {
    this.notificationService.error(message, title, error);
  }

  private showApiErrorToast(title: string, message: string, error: HttpErrorResponse) {
    this.notificationService.apiError(message, error, title);
  }

  private shouldSendError(error: Error): boolean {
    // by only logging errors that are not blacklisted and not cached, we avoid sending duplicate errors
    // and also avoid sending errors from bots that are not relevant to the user experience
    return !this.isBrowserAgentBlacklisted() && !this.cachedErrors[error.message];
  }

  private isBrowserAgentBlacklisted(): boolean {
    return this.blacklistedBrowserAgents.some((browserAgent) => navigator.userAgent.includes(browserAgent));
  }

  private cacheError(error: Error): void {
    this.cachedErrors[error.message] = error;
  }
}
